/**
 * App-wide shim over the `ui-common-components` design system.
 *
 * vite.config.ts resolves every `import … from 'ui-common-components'` to this
 * file (except the import below), so call sites keep importing from the
 * package as usual.
 *
 * Why: the DS TextInput defaults to validation="none", and on that path
 * `formatDisplayValue()` ends in `return trimSpaces(val)` — run on every
 * keystroke, so a trailing space is stripped the instant it is typed and a
 * space can never be entered (e.g. an entity name like "Holding Co").
 * validation="custom" with no `pattern` keeps the value as typed and only
 * trims leading/trailing spaces on blur. An explicit validation other than
 * "none" (email, numeric, headerSearch, …) is passed through unchanged.
 */
import { forwardRef } from 'react';
import { Input as DsInput, type InputProps } from 'ui-common-components';

export * from 'ui-common-components';

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { validation, ...props },
  ref,
) {
  return (
    <DsInput
      ref={ref}
      validation={validation === undefined || validation === 'none' ? 'custom' : validation}
      {...props}
    />
  );
});
